import { render, staticRenderFns } from "./SettingVam.vue?vue&type=template&id=7c13832e&scoped=true&"
import script from "./SettingVam.vue?vue&type=script&lang=js&"
export * from "./SettingVam.vue?vue&type=script&lang=js&"
import style0 from "./SettingVam.vue?vue&type=style&index=0&id=7c13832e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13832e",
  null
  
)

export default component.exports